export default function RandomIcon(props) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 34H12C14.5181 34 16.8892 32.8144 18.4 30.8L28.6 17.2C30.1108 15.1856 32.4819 14 35 14H40M36 8L41.2929 13.2929C41.6834 13.6834 41.6834 14.3166 41.2929 14.7071L36 20M28 30L28.6 30.8C30.1108 32.8144 32.4819 34 35 34H40M6 14H12C14.5181 14 16.8892 15.1856 18.4 17.2L19 18M36 40L41.2929 34.7071C41.6834 34.3166 41.6834 33.6834 41.2929 33.2929L36 28"
        stroke="#FFB800"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}
